module.exports = __webpack_public_path__ + "static/media/logo-emb.65580626.png";